import config from './config/config';

const Utils = {
  JSON: (json: any) => {
    if (config.production) return null;
    return (
      <pre className='p-3 bg-gray-800 shadow-2xl rounded-md overflow-hidden text-yellow-300'>
        {JSON.stringify(json, null, 2)}
      </pre>
    );
  },
  getObjectKeyValue: (object: any) => {
    const keys = Object.keys(object).filter((k) => typeof object[k] === 'number');
    const values = keys.map((k) => object[k]);

    return [keys, values];
  },
  createQueryString(form: any) {
    return `&${new URLSearchParams(form).toString().replaceAll('null', '').replaceAll('undefined', '')}`;
  },
  htmlToText(htmlString: string) {
    let span = document.createElement('span');
    span.innerHTML = htmlString;
    return span.textContent || span.innerText;
  },
};

export default Utils;
